import React, { useEffect, useState,  useContext } from 'react';
import { Input, Table } from 'antd';
import http from '../../Http';
import utils from '../../utils';
import calc from './calc.js';
import { useTranslation } from 'react-i18next';

function getTableScroll() {
    var th = document.getElementsByClassName("ant-table-thead")[0];
    let tHeaderBottom = 0
    if (th) {
        tHeaderBottom = th.getBoundingClientRect().bottom
    }
    let height = `calc(100vh - ${tHeaderBottom + 74}px)`
    return height
}

function Outline(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext)

    const [searchInvSN, setSearchInvSN] = useState('')

    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(25)
    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState([])
    const [rowTotal, setRowTotal] = useState(0)

    const [scrollY, setScrollY] = useState("")

    useEffect(() => {
    setScrollY(getTableScroll())
    }, [])

    const dateTimeFormat = new Intl.DateTimeFormat();
    const timeZone = dateTimeFormat.resolvedOptions().timeZone;
    const offset = new Date().getTimezoneOffset();

    //获取所有逆变器概览列表
    useEffect(() => {
        let active = true;

        (async () => {
            setLoading(true)

            let resp = await http.post("integrated-inverter/outline/list", {
                PageNo: pageNo,
                PageSize: pageSize, 
                SerialNumber: searchInvSN,
                Timezone: timeZone,
                TimezoneOffset: Math.abs(offset)*60
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                return null;
            });

            if (!active) {
                return;
            }
            
            if (resp === null || resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load inverter list error")});
                setRowTotal(0);
                setRows([]);
                return;
            }

            console.log('inverters outline: ', resp.data)

            //对麦格瑞能带符号数的处理
            for(const row of resp.data.Rows) {
                if(row['Protocol'] === 'Megarevo') {
                    row['PBat'] = calc.convertComplement(row['PBat'])
                    row['PAC1GRID'] = calc.convertComplement(row['PAC1GRID'])
                    row['PAC2GRID'] = calc.convertComplement(row['PAC2GRID'])
                    row['PAC3GRID'] = calc.convertComplement(row['PAC3GRID'])
                }
            }

            setRowTotal(resp.data.RowTotal)
            setRows(resp.data.Rows)
            setLoading(false)
        })();

        return () => {
            active = false;
        };

    }, [pageNo, pageSize, searchInvSN]);

    

    return (
        <div className="inv-outline">
            <div className="inv-outline-header">
                <Input.Search
                    placeholder={t("Enter Inverter SN")}
                    allowClear
                    enterButton={t("Search")}
                    onSearch={(value) => setSearchInvSN(value)}
                    style={{width: 250}}
                />
            </div>
            <div className="inv-outline-main">
                <Table
                    columns={[
                        {
                            title: "",
                            width: 40,
                            fixed: 'left',
                            render: (v, r, idx) => {
                                return (pageNo * pageSize + idx + 1);
                            }
                        },{
                            title: t('SN'),
                            dataIndex: "SerialName",
                            width: 120,
                            fixed: 'left',
                        },{
                            title: t('OEM'),
                            dataIndex: "Protocol",
                            width: 120,
                            fixed: 'left',
                        },{
                            title: t('Model'),
                            dataIndex: "Model",
                            width: 120,
                            fixed: 'left',
                        },{
                            title: t('LastTime') + '(' + timeZone + ')',
                            dataIndex: "LastTime",
                            width: 120,
                            fixed: 'left',
                        },
                        {
                            title: t('Status'),
                            width: 80,
                            render: (r) => {
                                return r["ErrorCode1"]&&r['ErrorCode2'] ? 
                                    <div><img src="images/inverter/status_warning.png" width="16" height="16" style={{marginRight: '5px'}} />{t("Alarm")}</div> : 
                                    r["IsOnline"]==1 ? 
                                    <div><img src="images/inverter/status_normal.png" width="16" height="16" style={{marginRight: '5px'}} />{t("Normal")}</div> :
                                    r["IsOnline"]==0 ? <div><img src="images/inverter/status_offline.png" width="16" height="16" style={{marginRight: '5px'}} />{t("Offline")}</div> : ''
                            },
                        },
                        {
                            title: t('SolarPower'),
                            dataIndex: 'PDC',
                            width: 80,
                            render: (v, r) => {
                                return v ? calc.power(v, r['Protocol']) + ' W' : '0 W'
                            }
                        },
                        {
                            title: t('ChargePower'),
                            dataIndex: 'PBat',
                            width: 80,
                            render: (v, r) => {
                                if(!v) return '0 W';
                                if(r['Protocol'] === 'Senergy' || r['Protocol'] === 'Thinkpower') {
                                    return v < 0 ? Math.abs(calc.power(v, r['Protocol'])) + ' W' : '0 W'
                                } else if(r['Protocol'] === 'Megarevo') {
                                    return v > 0 ? calc.power(v, r['Protocol']) + ' W' : '0 W'
                                } else {
                                    return '0 W'
                                }
                            }
                        },
                        {
                            title: t('DischargePower'),
                            dataIndex: 'PBat',
                            width: 100,
                            render: (v, r) => {
                                if(!v) return '0 W';
                                if(r['Protocol'] === 'Senergy' || r['Protocol'] === 'Thinkpower') {
                                    return v > 0 ? calc.power(v, r['Protocol']) + ' W' : '0 W'
                                } else if(r['Protocol'] === 'Megarevo') {
                                    return v < 0 ? Math.abs(calc.power(v, r['Protocol'])) + ' W' : '0 W'
                                } else {
                                    return '0 W'
                                }
                            }
                        },
                        {
                            title: t('Load'),
                            width: 60,
                            render: (v, r) => {
                                return v ? calc.power(Number(r['PAC1LOAD']) + Number(r['PAC2LOAD']) + Number(r['PAC3LOAD']), r['Protocol']) + ' W' : '0 W'
                            }
                        },
                        {
                            title: t('SolarYielding'),
                            dataIndex: 'ETotal',
                            width: 80,
                            render: (v, r) => {
                                return v ? calc.energy(v, r['Protocol']) + ' kWh' : '0 kWh'
                            }
                        },
                        {
                            title: t('BatteryDischarge'),
                            dataIndex: 'ETotalBatDischrg',
                            width: 80,
                            render: (v, r) => {
                                return v ? calc.energy(v, r['Protocol']) + ' kWh' : '0 kWh'
                            }
                        },
                        {
                            title: t('FeedEnergy'),
                            dataIndex: 'ETotalToGrid',
                            width: 80,
                            render: (v, r) => {
                                return v ? calc.energy(v, r['Protocol']) + ' kWh' : '0 kWh'
                            }
                        },
                        {
                            title: t('ConsumptionEnergy'),
                            dataIndex: 'ETotalLOAD',
                            width: 100,
                            render: (v, r) => {
                                return v ? calc.energy(v, r['Protocol']) + ' kWh' : '0 kWh'
                            }
                        },
                    ]}
                    pagination={{
                        pageSizeOptions: [25,50,100],
                        current: pageNo+1,
                        pageSize: pageSize,
                        total: rowTotal,
                        showSizeChanger: true,
                        showTotal: (total) => {return t("Total {{total}}", {total})},
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                        },
                        onChange: (page, pageSize) => {
                            setPageNo(page-1);                                
                        }
                    }}
                    tableLayout="fixed"
                    bordered={true}
                    size="small"
                    loading={loading}
                    rowKey="ID"
                    dataSource={rows}
                    scroll={{x: "max-content", y:scrollY}}
                >
                </Table>
            </div>
        </div>
    )
}

export default Outline;